import "./App.css";
import Cover from "./components/cover";
import Features from "./components/features";
import Navbar from "./components/navbar";
import Help from "./components/help";
import ScrollToTopButton from "./components/ScrollToTopButton";
import AppPic from "./components/appPic";
import TermsAndConditionsModal from "./components/terms";
import PrivacyPolicyModal from "./components/privacyPolicy";
import Footer from "./components/footer";
import React from "react";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Cover />
      <Features />
      <Help />
      <AppPic />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
